<template>
    <v-card>
      <v-card-title>
        <span class="headline">Group</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs5 v-if="newGrp">
                <v-text-field :label="labels.vehGrp" v-model="vehGrpForm.vehGrp" :error-messages="errors.collect('vehGrp')" data-vv-name="vehGrp" :data-vv-as="labels.vehGrp" v-validate="'required|numeric|max:10'"></v-text-field>
              </v-flex>
              <v-flex xs5 v-else>
                <v-subheader class="queryLabel">{{labels.vehGrp}}</v-subheader>
                <div class="title">{{vehGrpForm.vehGrp}}</div>
              </v-flex>
              <v-flex>
                <v-text-field :label="labels.description" v-model="vehGrpForm.vehGrpDesc" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'required|entry|max:100'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'vehGrpForm': Object,
    'newGrp': Boolean
  },
  data() {
    return {
      labels: {
        vehGrp: 'Group Code*',
        description: 'Group Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vehGrpForm.vehGrp = undefined
      this.vehGrpForm.vehGrpDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newGrp) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vehicle.menu.createVehGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.vehGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vehicle.menu.updateVehGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.vehGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
